import { Component, Input, ViewChild } from '@angular/core';
import { ISubscribeData, ISubscribeAgreementData } from './subscribe/component/subscribe/subscribe.component';
import { IUProperty, UProperty } from '../../core/interface/umbraco-property';
import { Html } from '../../core/interface/types';

export interface ISubscribePanelData {
  description: IUProperty<string>;
  title: IUProperty<string>;
  agreementText: IAgreementTextItem;
  anchor: IUProperty<string>;
  cookiePolicyPageUrl?: string;
  cookiePolicyTitle?: string;
  reCaptchaSecret: string;
  inputLabel: string;
}

export interface IAgreementTextItem {
  description: IUProperty<Html>;
  name: string;
  title: IUProperty<string>;
  url: string;
}

@Component({
  selector: 'ubl-subscribe-panel',
  templateUrl: './subscribe-panel.component.html',
  styleUrls: ['./subscribe-panel.component.less']
})
export class SubscribePanelComponent {
  @Input() data: ISubscribePanelData;

  subscribeData: ISubscribeData;
  showModal: boolean;
  ngOnInit()
  {
    if (this.data) {
      let mapped = UProperty.extract<ISubscribePanelData, ISubscribeData>(this.data,
        ['title', 'description', 'agreementText', 'inputLabel']);
      
      if (mapped.agreementText) {
        const {description, title} = UProperty.extract<IAgreementTextItem, ISubscribeAgreementData>(mapped.agreementText as any,
          ['description', 'title',]);
          
        mapped.agreementText.description = description;
        mapped.agreementText.title = title;
      }

      mapped.cookiePolicyPageUrl = this.data && this.data.cookiePolicyPageUrl;
      mapped.cookiePolicyTitle = this.data && this.data.cookiePolicyTitle;
      mapped.reCaptchaSecret = this.data && this.data.reCaptchaSecret;
      mapped.inputLabel = this.data && this.data.inputLabel;
      
      this.subscribeData = mapped;
    }
  }

  showAgreements()
  {
    this.showModal = true;
  }
}
